import React, { FC, useRef, MouseEvent } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useSelector } from 'react-redux';
import moment from 'moment';

import { fc } from 'i18n';
import { TepIntents } from 'constants/tep';
import { ITepEntryPass, ITepLease } from 'types/tep';
import DatePicker from 'core/react/general/form/DatePicker';
import { leasesCellSelector } from 'core/redux/selectors/tep';

import styles from './styles.module.css';

interface ICellProps {
  entryPass: ITepEntryPass;
}

export const SinceCell: FC<ICellProps> = ({ entryPass }) => {
  const { id, intent } = useSelector(leasesCellSelector);

  const ref = useRef<HTMLDivElement | null>(null);

  const { control, formState } = useFormContext<Partial<ITepLease>>();

  const endOn: Date | undefined = useWatch({ control, name: 'endOn' });

  const error = formState.errors.startOn?.message;

  const isEdit = intent === TepIntents.InlineEdit && entryPass.id === id;

  const disabledDate = (date: Date) => {
    const isBeforeToday = moment(date).isBefore(moment(new Date()), 'day');

    return endOn ? isBeforeToday || moment(date).isAfter(moment(endOn), 'day') : isBeforeToday;
  };

  const stopPropagation = (event: MouseEvent) => event.stopPropagation();

  return isEdit ? (
    <Controller
      control={control}
      name="startOn"
      rules={{ required: fc('please select start date') }}
      render={({ value, onChange }) => (
        <div className={styles.datePicker} onClick={stopPropagation}>
          <DatePicker
            placeholder={fc('start date')}
            value={value ? new Date(value) : null}
            onChange={onChange}
            disabledDate={disabledDate}
          />
          {/*/!*TODO: error messages should be moved to corresponding form components when they are being refactored*!/*/}
          {!!error && <div className={styles.error}>{error}</div>}
        </div>
      )}
    />
  ) : (
    <div ref={ref}>{entryPass.lease?.startOn ? moment(entryPass.lease.startOn).format('YYYY-MM-DD') : '-'}</div>
  );
};
